import { showErrorResponse } from "../../app/utils/common/Functions";
import { showSuccessToast } from "../../app/utils/common/Toast";
import { createProjectAPI, getAllProject, updateProjectAPI } from "../Apis/projectApi";


export const projectReducer = (builder) => {
    builder
        .addCase(getAllProject.pending, (state) => {
            state.loading = true;

        })
        .addCase(getAllProject.fulfilled, (state, action) => {
            state.loading = false;
            state.projects = action.payload.data;
            state.isProjectUpdated = false;
        })
        .addCase(getAllProject.rejected, (state, action) => {
            showErrorResponse(action.payload);
        })
        .addCase(createProjectAPI.pending, (state) => {
            state.loading = true;

        })
        .addCase(createProjectAPI.fulfilled, (state, action) => {
            state.loading = false;
            showSuccessToast("Project created successfully");
            state.isProjectUpdated = true;
        })
        .addCase(createProjectAPI.rejected, (state, action) => {
            state.loading = false;
            showErrorResponse(action.payload);
        })
        .addCase(updateProjectAPI.pending, (state) => {
            state.loading = true;

        })
        .addCase(updateProjectAPI.fulfilled, (state, action) => {
            state.loading = false;
            showSuccessToast("Project updated successfully");
            state.isProjectUpdated = true;
        })
        .addCase(updateProjectAPI.rejected, (state, action) => {
            state.loading = false;
            showErrorResponse(action.payload);
        })

};
